const FeatureShowcaseSection = ({
  eyebrow,
  title,
  description,
  bullets = [],
  children,
  reverse = false,
  id,
  visualWide = false,
}) => {
  const textBlock = (
    <div className="flex flex-col justify-center lg:pr-2">
      {eyebrow && (
        <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-orange-400 sm:text-xs">
          {eyebrow}
        </p>
      )}
      <h2 className="mt-3 text-xl font-bold text-white sm:text-2xl md:text-3xl lg:text-[2rem] lg:leading-tight">
        {title}
      </h2>
      <p className="mt-3 text-xs leading-relaxed text-white/70 sm:mt-4 sm:text-sm md:text-[15px]">
        {description}
      </p>
      {bullets.length > 0 && (
        <ul className="mt-5 space-y-2.5 sm:mt-6 sm:space-y-3">
          {bullets.map((item) => (
            <li
              key={item}
              className="flex items-start gap-2.5 text-xs text-white/80 sm:gap-3 sm:text-sm md:text-[15px]"
            >
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-orange-500" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  const visualBlock = (
    <div className="relative min-w-0">
      <div className="absolute -inset-4 rounded-[28px] bg-gradient-to-br from-orange-500/20 via-transparent to-blue-500/15 blur-2xl" />
      <div className="relative min-w-0">{children}</div>
    </div>
  );

  return (
    <section id={id} className="py-16 md:py-24">
      <div
        className={`grid items-center gap-8 lg:gap-10 xl:gap-12 ${
          visualWide
            ? "lg:grid-cols-[minmax(0,0.82fr)_minmax(0,1.28fr)]"
            : "lg:grid-cols-2"
        } ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}
      >
        {textBlock}
        {visualBlock}
      </div>
    </section>
  );
};

export default FeatureShowcaseSection;
